/**
 * Parallax Funktionalität hinzufügen
 *
 * Der Parallax Effekt wird über den containerSelector (jquery Selector für den Parallax Container) angewendet. Beim scrollen wird die vertikale Position der Scrollbar an den Parallax Container übergeben.
 * Über CSS wird dann das Element beim scrollen mit der Scrollposition / 2 verschoben. (WICHTIG: Es kann im Internet Explorer zu unschönen Effekten beim Scrollen kommen)
 * Events: window.scroll
 *
 * @param {string} containerSelector - jQuery Selector für den Parallax Container
 * @return {undefined}
 */
function nc_initParallax(containerSelector) {
    var moduleLogger = LoggerManager.get('parallax').setPrefix('Selektor: ' + containerSelector);
    moduleLogger.trace('INIT START');
    $(window).scroll(function () {
        nc_parallax(containerSelector);
    });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initParallax
 */
function nc_parallax(containerSelector) {
    // Beim Scrollen wird die vertikale Position der Scrollbar als Style an den Parallax Container übergeben.
    scrollPos = $(containerSelector).scrollTop();
    $(containerSelector).css({
        'transform': 'translate3d(0px, ' + (scrollPos / 2) + 'px, 0px)'
    });
}